import { getEnv } from "../env";

/**
 * Google sign-in configuration for the console.
 *
 * Login is verified server-side by @thema/data-api's console gate
 * (POST /auth/check/console): it validates the Google ID token against
 * GOOGLE_CLIENT_ID and checks the caller's `console` flag in the `auth_users`
 * allowlist (the thema_app app DB), returning { allowed, email, ... }. This
 * replaces the old AWS allowlist Lambda — logins are now DB-backed.
 *
 * Verify-URL resolution (all browser-exposed, non-secret values):
 *   1. VITE_CONSOLE_AUTH_VERIFY_URL — explicit full endpoint override.
 *   2. VITE_DATA_API_URL — the data-api base; `/auth/check/console` is appended.
 *   3. The deployed Cloud Run data-api as a baked-in default.
 * GOOGLE_CLIENT_ID MUST match the data-api's GOOGLE_CLIENT_ID env.
 */
const DATA_API_BASE =
  getEnv("VITE_DATA_API_URL") || "https://data-api-833271167201.us-central1.run.app";

/**
 * Data-API base URL (trailing slash stripped). Beyond the login gate, this is
 * the base for the authenticated per-wallet analytics API and the self-service
 * wallet-bind endpoint (POST /auth/me/wallet) the connect gate calls.
 */
export const DATA_API_URL = DATA_API_BASE.replace(/\/+$/, "");

export const AUTH_VERIFY_URL =
  getEnv("VITE_CONSOLE_AUTH_VERIFY_URL") || `${DATA_API_URL}/auth/check/console`;

export const GOOGLE_CLIENT_ID =
  getEnv("VITE_GOOGLE_CLIENT_ID") ||
  "833271167201-m6it4nbuh2u2fqq48hdrf4cd1dgoda3n.apps.googleusercontent.com";
